import React from 'react';
import IconType from './iconType';

function CalenderIcon({ color = '#424242', width = 20, height = 20 }: IconType) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M7.08203 2.71094V4.89844"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.918 2.71094V4.89844"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.80078 7.875H16.1966"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5625 7.45052V13.6484C16.5625 15.8359 15.4688 17.2943 12.9167 17.2943H7.08333C4.53125 17.2943 3.4375 15.8359 3.4375 13.6484V7.45052C3.4375 5.26302 4.53125 3.80469 7.08333 3.80469H12.9167C15.4688 3.80469 16.5625 5.26302 16.5625 7.45052Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6926 11.2396H12.6992"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6926 13.4271H12.6992"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.9973 11.2396H10.0038" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.9973 13.4271H10.0038" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M7.30198 11.2396H7.30853"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.30198 13.4271H7.30853"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CalenderIcon;
